import React from "react";
import { Activity, Bell, CheckCircle, AlertTriangle, Clock } from "lucide-react";
import "./RecentActivity.css";

const RecentActivity = ({ activities }) => {
  return (
    <div className="recent-activity-card glass-card">
      <div className="activity-header">
        <div className="header-title">
          <Activity size={18} className="icon-blue" />
          <span>Recent Activity</span>
        </div>
      </div>
      
      <div className="activity-list">
        {activities.map((item, index) => (
          <div key={index} className="activity-item">
            <div className="activity-main">
              <div className={`activity-dot ${item.type}`}></div>
              <div className="activity-details">
                <span className="activity-text">{item.title}</span>
                <span className="activity-time">
                  <Clock size={12} />
                  {item.time}
                </span>
              </div>
            </div>
            
            <div className={`activity-status-tag ${item.type}`}>
              {item.type.toUpperCase()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;
